import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Conta suspensa',
  description: 'O que a conta divulga sai do app enquanto ela estiver suspensa. Nada foi apagado.',
  noteLabel: 'Motivo',
  contact: 'Falar com a Bodyprint',
} satisfies TranslationTree;
